import { render, staticRenderFns } from "./BookBasicMain.vue?vue&type=template&id=6d538d51&scoped=true&"
import script from "./BookBasicMain.vue?vue&type=script&lang=js&"
export * from "./BookBasicMain.vue?vue&type=script&lang=js&"
import style0 from "./BookBasicMain.vue?vue&type=style&index=0&id=6d538d51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d538d51",
  null
  
)

export default component.exports